// React
import { Fragment, useEffect, useState } from "react"

// Assets
import 'assets/css/style.css'
import Banner from 'assets/images/banner.webp'

// Components
import { ActionButton } from "components"
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap"

// Third-Party Library
import { Link, useNavigate } from "react-router-dom"
import useToggle from "@react-hook/toggle"

const Home = ({ baseData }) => {
  // Hooks
  const navigate = useNavigate()

  useEffect(() => window.scrollTo(0, 0), [])

  const ServiceSection = () => {
    // Hooks
    const [show, toggle] = useToggle(false, true)
    const [data, setData] = useState({})

    const buyHandler = (value, val, serviceToCart) => {
      navigate(value, {
        state: {
          service: serviceToCart
        }
      })
    }

    const ModalSection = () => (
      <Modal isOpen={true} toggle={toggle} centered size="lg">
        <ModalHeader className="border-0" toggle={toggle} />

        <ModalBody className="p-0">
          <section className="px-4 text-center">
            <h4 className="fw-bold">{data.name}</h4>
            <h5 className="fw-bold">Inclusions</h5>
          </section>

          <div className="my-3">
            <img src={`${process.env.REACT_APP_BASE_URL}${data.image2}`} alt={data.name} className="w-100" />
          </div>

          <section className="px-4 my-3">
            <div dangerouslySetInnerHTML={{ __html: data.detail2 }} />

            <Row className="mt-2 justify-content-center align-items-stretch row-cols-auto">
              {data.online_service.map((val, index) => {
                // Variables
                const save = parseInt(data[`walk_in_${val.type.toLowerCase()}_price`] ?? 0) - val.price

                return (
                  <Col key={index} className="border border-dark bg-primary d-flex flex-column align-items-center px-0" style={{ width: 300 }}>
                    <ActionButton
                      block
                      className="text-uppercase text-white py-3 rounded-0 rounded-bottom"
                      style={{ fontSize: 18 }}
                      onClick={() => {
                        toggle()
                        buyHandler(data.slug, data, val)
                      }}
                    >
                      <div>{val.name}</div>
                      <div className="text-uppercase">{val.name.includes("KTP") && "*"} idr {val.price.toLocaleString('id-ID')}</div>
                      {save > 0 && <div className="text-uppercase text-danger">save idr {save.toLocaleString('id-ID')}</div>}
                    </ActionButton>
                  </Col>
                )
              })}
            </Row>
          </section>

          <ActionButton
            block
            className="text-uppercase text-white my-3 py-3 rounded-0"
            color="gold"
            style={{ fontSize: 18 }}
            onClick={() => {
              toggle()
              buyHandler(data.slug, data)
            }}
          >
            <div>buy now</div>
          </ActionButton>

          <div className="embed">
            <iframe src={`${data.video_link}?controls=0&autoplay=1`} title="Youtube" width="100%" height="auto" />
          </div>
        </ModalBody>
      </Modal>
    )

    return (
      <Fragment>
        <Row className="justify-content-center row-cols-auto">
          {baseData.category.map((val, index) => {
            return (
              <Col key={index} className="d-flex flex-column mt-3" style={{ width: 300 }}>
                <h5 className="fw-bolder">{val.name}</h5>

                <img className="img-fluid w-100 border" src={`${process.env.REACT_APP_BASE_URL}${val.image}`} alt={val.name} />

                <div className="d-flex justify-content-center">
                  <div className="mx-auto" style={{ marginTop: -9 }}>
                    <div className="bg-white rounded-pill p-2">
                      <ActionButton
                        className="rounded-pill text-uppercase text-white fs-6 px-5"
                        color="gold"
                        onClick={() => buyHandler(val.slug, val)}
                      >
                        buy now
                      </ActionButton>
                    </div>
                  </div>
                </div>

                {Boolean(val.detail && val.detail !== "&nbsp") && <div className="overflow-auto text-start" style={{ lineHeight: 1.2 }} dangerouslySetInnerHTML={{ __html: val.detail }} />}


                <div className="mt-auto">
                  <ActionButton
                    className="text-uppercase text-white mb-3"
                    onClick={() => {
                      setData(val)
                      toggle()
                    }}
                  >
                    view inclusions
                  </ActionButton>

                  <section style={{ minHeight: 150 }}>
                    <div className="position-relative text-primary">
                      <hr className="border border-3 border-primary bg-primary" />

                      <div className="position-absolute top-50 start-50 translate-middle">
                        <h6 className="bg-white text-uppercase fw-bolder px-3 mb-0" style={{ fontSize: 10 }}>best for</h6>
                      </div>
                    </div>

                    <p style={{ fontWeight: 500, lineHeight: 1.2 }} dangerouslySetInnerHTML={{ __html: val.best_for }} />
                  </section>
                </div>
              </Col>
            )
          })}
        </Row>

        {show && <ModalSection />}
      </Fragment>
    )
  }

  return (
    <Fragment>
      <div className="my-3 text-center">
        <section className="container">
          <img src={Banner} alt="Banner" className="img-fluid" />

          <section className="py-2 text-white" style={{ backgroundColor: "#00183e", fontSize: 22 }}>
            <div>Finns Recreation Club has “Something for Everyone”</div>
            <div>Check out our amazing range of passes to cater for anyone. Choose yours!</div>
          </section>
        </section>

        <section className="container-fluid">
          <ServiceSection />
        </section>

        <section className="container">
          <div className="bg-gold text-center text-white my-3 py-4">
            <h3 className="fw-bold">Ultimate Experience Super Fun Pass Voucher Redemption</h3>
            <h5>Already have a Super Fun Pass voucher from your Ultimate Experience at Finns Beach Club? Hit the link below to redeem your free pass using the unique code provided via email</h5>

            <Link to="/misc/ultimate-experience">
              <ActionButton outline color="light">Redeem Now</ActionButton>
            </Link>
          </div>
        </section>
      </div>
    </Fragment>
  )
}

export default Home